import { tv, type VariantProps } from 'tailwind-variants'

import { INTENTION_TYPE } from '../../../models/Intention.enums'

export const intentionCardVariants = tv({
  slots: {
    base: 'max-w-full min-w-0 p-4 gap-2',
    header: 'min-w-0 flex-row items-center gap-2 p-0',
    text: 'flex-1',
    avatarPlaceholder: 'h-12 w-12 rounded-full',
    body: 'p-0',
    footer: 'p-0',
  },
  variants: {
    color: {
      default: {
        base: 'bg-white',
        text: 'text-default-text-contrast-default',
        avatarPlaceholder: 'bg-default-bg-medium',
      },
      primary: {
        base: 'bg-primary-bg-light',
        text: 'text-primary-text-contrast-default',
        avatarPlaceholder: 'bg-primary-bg-medium',
      },
      success: {
        base: 'bg-success-bg-high',
        text: 'text-success-text-contrast-high',
        avatarPlaceholder: 'bg-success-bg-medium',
      },
    },
    isLoading: {
      true: {
        base: 'animate-pulse',
        body: 'p-0 w-96',
        text: 'p-0 h-10',
      },
    },
    type: {
      [INTENTION_TYPE.ARRIVAL]: {},
      [INTENTION_TYPE.BIRTHDAY]: {},
      [INTENTION_TYPE.INTENTION]: {},
    },
  },
  compoundVariants: [
    {
      isLoading: true,
      type: INTENTION_TYPE.INTENTION,
      body: 'h-24',
    },
  ],
  defaultVariants: {
    isLoading: false,
    color: 'default',
  },
})

export type TIntentionCardVariantProps = VariantProps<typeof intentionCardVariants>
export type TIntentionCardSlots = keyof ReturnType<typeof intentionCardVariants>
